module.exports = __webpack_public_path__ + "static/notice-contentlength-do-196d3068a88b95210bfd2f86f5b02c9a.png";